import React from 'react'
import SectionCard from '../../shared/SectionCard'
import ContactItem from '../../shared/ContactItem'
import './style.css'

const ContactInformation = ({ requestDetails }) => {
    return (
        <SectionCard icon="mdi:phone" titleKey="contact-info">
            <div className="contact-information-list">
                <ContactItem 
                    icon="mdi:phone" 
                    labelKey="Phone" 
                    value={requestDetails?.phoneNumber} 
                />

                <ContactItem 
                    icon="mdi:email" 
                    labelKey="Email" 
                    value={requestDetails?.email}
                    isLink
                    linkType="email"
                />

                {requestDetails?.websiteUrl && (
                    <ContactItem 
                        icon="mdi:web" 
                        labelKey="websiteUrl" 
                        value={requestDetails?.websiteUrl}
                        isLink
                        linkType="url"
                    />
                )}
            </div>
        </SectionCard>
    )
}

export default ContactInformation

